// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__aX0f4","fadeIn":"Card_fadeIn__2yaYF","fadeOut":"Card_fadeOut__1QjRH"};